import { takeEvery, fork, put, all, call, select } from 'redux-saga/effects';

import { GET_PLAYER, GET_DETAILED_CAMPAIGN, GET_PLAYER_LIST } from './actionTypes';
import {
    getPlayerSuccess,
    getPlayerFailed,
    getDetailedCampainsSuccess,
    getDetailedCampainsFailed,
    getPlayerListSuccess,
    getPlayerListFailed
} from './actions';
import {noParamGet, paramPost} from '../../../apiHelpers/commonApiHelper';
import toastr from 'toastr';

function* getScreen() {
    try {
        const response = yield call(noParamGet, '/api/v1/players');
        if(response.status === 200) {
            yield put(getPlayerSuccess(response.data));
        } else {
            yield put(getPlayerFailed());
        }

    } catch (error) {
        yield put(getPlayerFailed());
    }
}


function* getDetailedCams({ payload }) {
    try {
        const response = yield call(paramPost, '/api/v1/players/get_detailed_campaigns', payload);
        if(response.status === 200) {
            yield put(getDetailedCampainsSuccess(JSON.parse(response.data.campaigns)));
        } else {
            yield put(getDetailedCampainsFailed());
        }

    } catch (error) {
        yield put(getDetailedCampainsFailed());
    }
}


function* getPlayersList() {
    try {
        const response = yield call(noParamGet, '/api/v1/players/player_list');
        if(response.status === 200) {
            yield put(getPlayerListSuccess(JSON.parse(response.data.players)));
        } else {
            yield put(getPlayerListFailed());
        }

    } catch (error) {
        yield put(getPlayerListFailed());
    }
}


export function* watchGetPlayer() {
    yield takeEvery(GET_PLAYER, getScreen)
}

export function* watchGetDetailedCampaign() {
    yield takeEvery(GET_DETAILED_CAMPAIGN, getDetailedCams)
}

export function* watchGetPlayerList() {
    yield takeEvery(GET_PLAYER_LIST, getPlayersList)
}

function* ScreenSaga() {
    yield all([
        fork(watchGetPlayer),
        fork(watchGetDetailedCampaign),
        fork(watchGetPlayerList)
    ]);
}

export default ScreenSaga;